import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import WysiwygField from '../../../WysiwygField';
import './style.scss';

const CollapsableStepPlan = ({ title, body, className, index, roundedIcon, variant, OpenStepPlan }) => {

  const [OpenAnswer, setOpenAnswer] = useState(false);

  const toggleAnswer = () => {
    setOpenAnswer(!OpenAnswer);
  };

  useEffect(() => {
    setOpenAnswer(OpenStepPlan);
  }, [OpenStepPlan]);

  return (
    <div
      className={classnames(className, 'CollapsableStepPlan', { CollapsableStepPlan__open: OpenAnswer })}
      onClick={toggleAnswer}
    >

      <div className="CollapsableStepPlan__inner">
        <div className={classnames('CollapsableStepPlan__icon',
          {
            [`CollapsableStepPlan__icon--color-${variant}`]: variant,
            'CollapsableStepPlan__icon--color-green': !variant,
          })}>
          <div className={classnames(className, 'icon icon-plus icon-variant-0', { icon__rounded: roundedIcon })} />
        </div>
        <div className="CollapsableStepPlan__container">
          <strong className="CollapsableStepPlan__title">{title}</strong>
          <div className={classnames('CollapsableStepPlan__body', { CollapsableStepPlan__body__rounded: roundedIcon })}>
            {body && (
              <WysiwygField
                property="schema:text"
                html={body}
                className="subheading2"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CollapsableStepPlan;
